module.exports = __webpack_public_path__ + "static/media/A-Hearts.c7b48e1b.svg";